(() => {
  'use strict';
  const main = document.getElementById('MainContent');
  if (!main || main.dataset.amcContentStandards) return;
  main.dataset.amcContentStandards = 'true';
  const proseSelector = '.amc-product-content,.amc-pi__migrated,.standard_page__description,.amc-local__prose';
  const interactive = 'form,input,select,textarea,button,product-form,variant-selects,iframe,script';
  const isSpec = link => {
    const probe = `${link.getAttribute('href') || ''} ${link.textContent} ${link.getAttribute('aria-label') || ''}`.replace(/[_-]+/g, ' ');
    return /(?:spec(?:ification)?|data)\s*sheet|datasheet/i.test(probe) || (/\.pdf(?:[?#\s]|$)/i.test(probe) && /spec/i.test(probe));
  };
  function withdraw(link) {
    if (!isSpec(link)) return;
    const banner = link.parentElement;
    if (banner?.tagName === 'DIV' && /One-page factory spec sheet/i.test(banner.textContent) && !banner.querySelector(interactive)) {
      banner.remove();
    } else if (/download/i.test(link.textContent) || /\.pdf(?:[?#]|$)/i.test(link.getAttribute('href') || '')) {
      link.remove();
    } else {
      link.replaceWith(...link.childNodes);
    }
  }
  function normalize(root) {
    root.querySelectorAll('div[style],section[style],aside[style]').forEach(panel => {
      if (panel.closest(interactive) || panel.querySelector(interactive) || panel.hasAttribute('data-amc-content-panel') || panel.hasAttribute('data-amc-content-surface')) return;
      if (!/background/i.test(panel.getAttribute('style') || '')) return;
      if ([...panel.querySelectorAll('div[style],section[style],aside[style]')].some(child => /background/i.test(child.getAttribute('style') || ''))) return;
      const style = getComputedStyle(panel);
      if (style.backgroundImage !== 'none') {
        if (!/^(?:linear|radial)-gradient\(/.test(style.backgroundImage) || /url\(/i.test(style.backgroundImage)) return;
        const stops = [...style.backgroundImage.matchAll(/rgba?\(([\d.,\s]+)\)/g)].map(match => match[1].match(/[\d.]+/g).map(Number));
        if (stops.length < 2 || stops.some(stop => stop.length > 3 && stop[3] < .95)) return;
        const dark = stops.map(stop => (stop[0] * .2126 + stop[1] * .7152 + stop[2] * .0722) / 255 < .45);
        if (!dark.every(value => value === dark[0])) return;
        panel.setAttribute(dark[0] ? 'data-amc-content-panel' : 'data-amc-content-surface', '');
        return;
      }
      const parts = style.backgroundColor.match(/[\d.]+/g)?.map(Number);
      if (!parts || parts.length < 3 || (parts.length > 3 && parts[3] < .95)) return;
      const brightness = (parts[0] * .2126 + parts[1] * .7152 + parts[2] * .0722) / 255;
      panel.setAttribute(brightness < .45 ? 'data-amc-content-panel' : 'data-amc-content-surface', '');
    });
  }
  function scan(scope) {
    if (scope.nodeType !== 1) return;
    if (scope.matches('a[href]')) withdraw(scope);
    scope.querySelectorAll('a[href]').forEach(withdraw);
    if (scope.matches(proseSelector)) normalize(scope);
    scope.querySelectorAll(proseSelector).forEach(normalize);
  }
  scan(main);
  const pending = new Set();
  let frame = 0;
  const observer = new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === 1) pending.add(node);
    }
    if (!pending.size || frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      for (const node of pending) if (node.isConnected) scan(node);
      pending.clear();
    });
  });
  observer.observe(main, { childList: true, subtree: true });
  window.addEventListener('pagehide', () => {
    observer.disconnect();
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    pending.clear();
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      scan(main);
      observer.observe(main, { childList: true, subtree: true });
    }
  });
})();
